<template>
  <footer class="fixed-bottom">
    <p class="m-0 text-center">Copyright &copy; 2021 Delta IT . All Rights Reserved.</p>
  </footer>
</template>

<script>
export default {
  name: "Footer",
}
</script>

<style scoped></style>
